import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Divider, Button, Stack } from '@mui/material';
import { useOutletContext } from "react-router-dom";
import CreditAadhaarBar from '../../components/MyProfile/CreditAadhaarBar';
import SemiCircleProgress from "../../components/Dashboard/SemiCircleProgress";
import EsignStatusCardGroup from "./EsignStatusCardGroup";
import MultiLineChart from "../../components/Dashboard/MultiLineChart";
import AddCredits from "../../components/Esign/addCredits";

export default function Dashboard() {
  const { open } = useOutletContext();
  const { data = {}, status } = useSelector((state) => state.dashboard);
  const [allCraditData, setAllCraditData] = useState([]);
  const [allDataStatus, setAllDataStatus] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [addCreditOpen, setAddCreditOpen] = useState(false);
  const [paymentsuccess, setPaymentsuccess] = useState(false);
  const [loader, setLoader] = useState(false)
  const order = ['Completed', 'Pending', 'Expired'];

  useEffect(() => {
    if (data.status) {
      console.log(data)
      setAllCraditData(data.credits || {});
      setAllDataStatus(data.data || {});
    }
  }, [data.status, tabIndex]);

  console.log(tabIndex)
  return (<>

    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
        marginLeft: open ? "240px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        background: "#f9f9f9",
      }} 
    >
      <Box
        mt={10}
        style={{
          width: '100%',
          height: "calc(100% - 93px)",
          marginLeft: open ? "" : "1em",
        }}
      >
        <Typography noWrap component="p" sx={{ fontSize: '24px', fontWeight: 600,}}>
          eSign Overview
        </Typography>
        <Box sx={{ height: "calc(100% - 42px)", borderRadius: '12px', overflow: "auto", mt: "20px" }}>
          <Box sx={{ display: "flex", justifyContent: "center", gap: "20px"}}>
            {/* <Box display={{ display: "flex", width: "calc(100% * 71.93 / 100)", flexDirection: "column", gap: "23px" }}> */}
            <Box display={{ display: "flex", width: "100%", flexDirection: "column", gap: "23px" }}>
              <Box sx={{background: "#FFFFFF", borderRadius: '12px', }}>
                <CreditAadhaarBar
                  total={
                    Number(tabIndex) === 0
                      ? allCraditData?.aadhaar_credits?.total_credit_integer ?? 0
                      : allCraditData?.digital_credits?.total_credit_integer ?? 0
                  }
                  available={
                    Number(tabIndex) === 0
                      ? allCraditData?.aadhaar_credits?.credit_left_integer ?? 0
                      : allCraditData?.digital_credits?.credit_left_integer ?? 0
                  }
                  used={
                    Number(tabIndex) === 0
                      ? allCraditData?.aadhaar_credits?.credit_used ?? 0
                      : allCraditData?.digital_credits?.credit_used ?? 0
                  }
                  left={
                    Number(tabIndex) === 0
                      ? allCraditData?.aadhaar_credits?.credit_left_integer ?? 0
                      : allCraditData?.digital_credits?.credit_left_integer ?? 0
                  }
                  setAddCreditOpen={setAddCreditOpen}
                  tabIndex={tabIndex}
                  setTabIndex={setTabIndex}
                  showSelection={true}
                />
              </Box>
              {/* <Box sx={{background: "#FFFFFF", borderRadius: '12px', height: "calc(100% - 210px)" }}>
                  <MultiLineChart/>
              </Box> */}
            </Box>
            {/* <Box sx={{ width: "calc(100% * 26.28 / 100)", minHeight: "606px",  background: "#FFFFFF", borderRadius: '12px', marginRight: "12px", p: "5px" }}>
              <Box sx={{ width: "100%", minHeight: "62px", background: "linear-gradient(108.34deg, rgba(24, 92, 183, 0.06) 11.27%, rgba(197, 6, 12, 0.06) 96.88%)", borderRadius: "12px 12px 0 0", p: "25px 17px 24px 17px" }}>
                <Typography component="p" sx={{ fontSize: '18px', fontWeight: 600, color: "#202224", }}>
                  eSign Status
                </Typography>
              </Box>
              <Box sx={{ padding: "25px 20px" }}>
                <Box sx={{ background: "#F9F9F9", borderRadius: "18px", height: "150px", position: "relative" }}>
                  <SemiCircleProgress allDataStatus={allDataStatus} />
                </Box>
                <Box sx={{ mt: "31px" }}>
                  <EsignStatusCardGroup allDataStatus={allDataStatus} />
                </Box>
              </Box>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </Box>

    {(addCreditOpen || paymentsuccess) && <AddCredits addCreditOpen={addCreditOpen} setAddCreditOpen={setAddCreditOpen} loader={loader} setLoader={setLoader} paymentsuccess={paymentsuccess} setPaymentsuccess={setPaymentsuccess} />}
  </>);
}
